import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { translate } from '../../services';
import { ClipboardImport, ExcelImport, Tab } from '..';
import { connect } from 'react-redux';
import { 
  cartDispatcher,
  combineDispatchers,
  importDispatcher,
  messageDispatcher,
  siteSettingsState,
  combineStates,
  productState,
  productsDispatcher,
  priceDispatcher,
  analyticsDispatcher,
  identityState,
  superCodeDispatcher,
  flagDispatcher,
  AppStore
} from '../../store';
import { convertToLineItem, getMissingBomItemCodes, getUserAssignments,UserIdentity, getConfiguration } from '../../util';
import { browserHistory } from 'react-router'
import classNames from 'classnames';
import { Box, Button, Drawer, IconButton as MuiIconButton } from '@mui/material';
import { CloseIconNew, EditIConNew, MobileExcelImportIcon, closePopup } from '../../../style/images';
import { apiException } from '../../util';
import { isArray } from 'lodash';

export class ImportCartPanelComponent extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      productList: [],
      isBusy: false,
      file:"",
      component:"",
      toggle:"false"
    };

    this.items = [];
    this.importCart = this.importCart.bind( this );
    this.validate = this.validate.bind( this );
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  onValidationFinish( message, isValid, silent, timeout = 500,flag=true ) {
    if ( !silent || !isValid ) {
      this.mounted && this.setState( { isBusy: false } );
      this.props.notImporting();
      message.timeout = timeout;
      message && this.props.addMessage( message );
    }
   
    //this.importCart(flag);
    return isValid;
  }

   updateProducts = (productList,result,flag=false) => {
    if(result&& result.type==="message/set"){
      this.addMessage( result.item.messageText, result.item.messageType, 0 );
      this.mounted && this.setState( { isBusy: false } );
      this.props.importing();
      return false;
    }
    productList.forEach(ele=>{
      if(ele.product.indexOf("1SDA")>=0 && ele.product.indexOf("R0001")>0){
      var str = ele.product?.substring(0,ele.product.indexOf("R0001")+1)+"1";
      console.log(str);
      ele.product=str;
      }
     
    });
    this.mounted && this.setState( { productList }, () => this.importCart(flag) );
    this.isValidated = false;
    return true;
  }

  getExcelData = file => {
    this.mounted && this.setState( { isBusy: true } );
    this.props.importing();
    this.isValidated = false;
    this.props.importExcel( file ).then( response => {
      apiException(response, this.props.dispatch);
      //add products first to product list
      let productlist=[]
      response.data.forEach(d=>{
        if(d.importAccessories && d.importAccessories.length==0){
          productlist.push(d)
        }
      })
      response.data.forEach(d=>{
        if(d.importAccessories && d.importAccessories.length>0){

          productlist.push({...d,superCodeLSO:d.superCodeLSO=="-"?'待开':d.superCodeLSO})
        }
      })
      this.updateProducts( productlist, response.result, true ) }).catch(err=>console.log(err));
  }

  addMessage = ( messageText, messageType= 'confirmation', timeout= 0 ) => {
    return this.props.addMessage( {  timeout: timeout, messageText: translate( messageText ), messageType: messageType  } )
  }

  async validate( silent = false,flag=false ) {
    const { productList } = this.state;
    this.mounted && this.setState( { isBusy: true } );
    this.props.importing();
    this.items = [];
    let missedManditoryFields = [];

    let result = await this.props.validate( productList );
    let codes=[];
    let acc_codes=[];
    result.configurations.forEach(res=>{if(res.superCodeLSO){codes.push(res.superCodeLSO)}})
    result.configurations.forEach(prod=>{if(prod.configurableProduct){prod.bomItems.forEach(b=>acc_codes.push(b.name))}})
    if(codes && codes.length>0){productsDispatcher( AppStore.dispatch ).getProducts(codes).then(res=>
      priceDispatcher( AppStore.dispatch ).getPrices( res.products.map( product=> convertToLineItem(product, this.props.user) ) )
      );}
      if(acc_codes && acc_codes.length>0){
      productsDispatcher( AppStore.dispatch ).getProducts(acc_codes).then(res=>
        priceDispatcher( AppStore.dispatch ).getPrices( res.products.map( product=> convertToLineItem(product, this.props.user) ) )
        );  }

    if(result && result.products && result.products.length>1 ) {
      const removedProductList = result.products.filter(prod => prod.properties?.find( prop => prop.name == 'MountedOnly' && prop.value)).map(prod => prod.name);
      result.products = result.products.filter(prod => !removedProductList.includes(prod.name ));
  
      removedProductList.length > 0 && this.props.addMessage({
          timeout: 0,
          messageText: translate( '{count} can\'t be added to cart,as these are to be sold as Mounted Only {code}',{count : removedProductList.length, code: removedProductList.join(',') }  ),
          messageType: "warning",
        });
    }
      result?.configurations.forEach(configuration => {
        let assignmetsMap = new Map();
        configuration.configuration.assignments.forEach(assignment => {
          assignmetsMap.set(assignment.key,assignment.value);
        });
        configuration.configuration.model.children[0].variables.forEach(variable => {
          if(variable.properties.Required){
            if(!assignmetsMap.has(variable.fullyQualifiedName)){
              missedManditoryFields.push(variable.fullyQualifiedName);
            }
          }
        });

        if (missedManditoryFields.length > 0) {
          this.props.addMessage({
            timeout: 0,
            messageText: translate("some configurations are missing for {code}, Kindly update the configuration in cart", {code: configuration.materialDefinition}),
            messageType: "warning",
          });
        }
      });
      this.result = result;
      this.isValidated = true;
    if (result===undefined || result === null || ((result == undefined || result.configurations == "" ) && (result.products.length == 0) && flag)) {
      this.result = result;
      this.isValidated = true;
      return this.onValidationFinish( 
        {  messageText: translate("An error occured while Validating the Configuration. Please check the configuration and try again!!"),
        messageType: "error" },
        false,
        silent,
        0
      );
    }
    return this.onValidationFinish( 
        
      { messageText: result.validityInfo.invalidCodes + translate( result.validityInfo.message ), 
      messageType: result.validityInfo.isValid ? 'confirmation' : 'warning' },
      result.validityInfo.isValid,
      silent,
      result.validityInfo.isValid ? 2500 : 0
    );
  }

  setFile = (file)=>{
    this.setState({file:file})
  }

  onToggle = ()=>{
    this.setState({toggle:!this.state.toggle});
  }

  setTab = (tab)=>{
    this.setState({component:tab.component});
  }

  async importCart(flag=false) {
    const { products, user, siteSettings } = this.props;
    const { productList } = this.state;
    const isValid = this.isValidated || await this.validate( true,flag );
    let import_flag=true;
    let count=0;
    //for valid products we need to import, for invalid error/warning message to be shown. Import should not stop for valid ones.
    // if ( !isValid ) {
    //   return;
    // }
    if(isValid){
      const codes = getMissingBomItemCodes( [...this.result.products, ...this.result.configurations], products );
      await this.props.getProducts( codes ).then( response => { response && this.props.getPrices( response.products.map( (product) => convertToLineItem(product, user) ) ) });
      this.result.products.forEach( product => { count+=1;
        this.props.addToCart( { 
        product: {...product, additionalProducts: []}, 
        amount: productList.filter(item=>item.product==product.code || item.product==product.name).firstOrDefault()?.quantity || 1, 
        options: {},
       // noteByUser:productList.filter(item=>item.product==product.code || item.product==product.name)?.firstOrDefault()?.noteByUser  ,
        noteByUser:product.noteByUser!==null && typeof(product.noteByUser) !== "undefined"?product.noteByUser:'',
        import_flag        
      } ); 
        this.sendAnalytics ( product );
       productList.shift();
      });

      let readyAssembledproductlist = [];
      let readyAssembledlist = [];

      this.result.configurations?.forEach( configuration => { 
        const isReadyAssembled = ( user.country.indexOf('CBOL') > -1 || user.country.indexOf('Cbol') > -1 || 
          user.authenticationType == 'Apttus' || user.authenticationType == 'File' ) && 
          siteSettings.createSupercodeInSap && configuration;
        const accessories = getUserAssignments( configuration.configuration ).filter( a => !configuration.configuration.model.variables.any( i => i.name === a.key ) );
        if( isReadyAssembled && configuration.configuration && 
          configuration.configuration.productModelType === 1 && accessories.length > 0 ) {
            readyAssembledproductlist = [...readyAssembledproductlist,...getConfiguration(configuration,user)];
            readyAssembledlist = [...readyAssembledlist, productList.find(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO) )];
            productList.shift();
      } else {
          count+=1;
          let configurableProduct=productList.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))?.firstOrDefault()?.configurableProduct;
          let nstProductKey = Object.keys(this.props.products).find(p=> this.props.products[p] && configuration.superCodeLSO && (this.props.products[p].code==configuration.superCodeLSO || this.props.products[p].name==configuration.superCodeLSO));
          this.props.addToCart( {
          product: {...configuration, ...productList.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO)),...productList[0]?.importAccessories?.filter(k=> k.accessoryCode.includes("WA_") || accessories.find(a=>a.value ===k.accessoryCode)), 
          additionalProducts: [],
          looseadditionalProduct:configuration.looseAdditionalProduct, 
          fgProduct: configuration.fgProduct && configuration.fgProduct.length>0?configuration.fgProduct:this.props.products[configuration.superCodeLSO],
          bom:configuration.bomItems || productList.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))?.firstOrDefault()?.bomItems?.filter(b=> b.configuredAcc ),
          configurableProduct:isArray(configurableProduct) ? configurableProduct[0] :configurableProduct,
          NST_description:configuration.superCodeLSO && configuration.superCodeLSO!=="" && configuration.superCodeLSO!=="-" && nstProductKey && this.props.products[nstProductKey].description
          },
            amount: productList.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))?.firstOrDefault()?.quantity || 1,
            options: {},
            noteByUser:configuration.noteByUser!==null && typeof(configuration.noteByUser) !== "undefined"?configuration.noteByUser:'',
            //noteByUser:configuration.noteByUser || productList.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO))?.firstOrDefault()?.noteByUser  ,
            import_flag           
          } );
            this.sendAnalytics ( configuration );
            productList.shift();
          }
      })
      let productcount=count>1?'products':'product'
      let messageText=count+' '+translate(productcount) +' '+translate('added to cart')
      this.addMessage(  messageText,"confirmation",10000)
      ;
    // removing isReadyAssembled check so code won't enter this conditio
      if(readyAssembledproductlist?.length) {
        this.props.createSuperCode( readyAssembledproductlist )
        .then(superCodeResponses => {
          for(let superCodeResponse of superCodeResponses.data) {
            if( superCodeResponse.errors && superCodeResponse.errors.length ){
              this.addMessage( "Some error occured while creating supercode", "error", 0 );
            }
            // Fix-On importing, items with same id get added as one to cart although one has accessories and other does not.
            else{
              this.addMessage( superCodeResponse.response );
              this.result.configurations.forEach(configuration=>{
                const accessories = getUserAssignments( configuration.configuration ).filter( a => !configuration.configuration.model.variables.any( i => i.name === a.key ) );
                if((accessories && accessories.length>0) && (superCodeResponse.variantId ===configuration.code || superCodeResponse.variantId ===configuration.name) && (superCodeResponse.superCodeLSO==configuration.superCodeLSO)){
                  configuration.superCode = superCodeResponse.superCode;
                  this.props.addToCart( { 
                    product: {...configuration, ...readyAssembledlist.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO)).firstOrDefault(prod => prod?.importAccessories), additionalProducts: []},
                    amount: readyAssembledlist.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO)).firstOrDefault()?.quantity || 1,
                    options: {},
                    noteByUser:configuration.noteByUser!==null && typeof(configuration.noteByUser) !== "undefined"?configuration.noteByUser:'',
                    //noteByUser:configuration.noteByUser || readyAssembledlist.filter(item=>(item.product==configuration.code || item.product== configuration.name) && (item.superCodeLSO==configuration.superCodeLSO)).firstOrDefault()?.noteByUser  
                   } )
                    this.sendAnalytics ( configuration );
                    readyAssembledlist.shift();
                }
              })             
            }
          }
        })
      }
  }
    if( ( user.authenticationType === 'Cbol' )) {
      window.location.href = '#/cart';
      this.setState( { validated: true } );
    }
    // this.props.hidePopup();
    this.mounted && this.setState( { isBusy: false } );
    this.props.notImporting();
    this.props.onClose()
    // return this.onValidationFinish( 
      
    //   { messageText: this.result.validityInfo.invalidCodes + translate( this.result.validityInfo.message ), 
    //   messageType: this.result.validityInfo.isValid ? 'confirmation' : 'warning' },
    //   this.result.validityInfo.isValid,
    //   true,
    //   this.result.validityInfo.isValid ? 2500 : 0
    // );
  }

  sendAnalytics = product => {
    let action = 'product';
    const productList = [product.name]
    if ( product.configuration ) {
      action = 'configuration';
      const accessories = getUserAssignments( product.configuration ).filter( a => !product.configuration.model.variables.any( i => i.name === a.key ) );
      accessories.forEach( acc => productList.push( acc.value ) );
    }
    this.props.captureEvent( 'import-cart', action, [...new Set( productList )].join( ';' ), ['commonTracker'] );
     //ga4
    
     dataLayer.push({
      'event':'import_cart',
      event_action:action,
      event_label :[...new Set( productList )].join( ';' ),
      event_instance:this.props.siteSettings.properties.GaInstance,
      event_country: this.props.siteSettings.properties.GaCountry,
      location_url:window.location.href
    })
  }

  render() {
    const { siteSettings } = this.props;
    const { isBusy, productList } = this.state;

    const tabs = [
      [
        siteSettings.importSettings.excel && { title: translate( 'Import Excel file' ),
        image:MobileExcelImportIcon,
        component: <ExcelImport onClose={this.props.onClose} import={ this.getExcelData } setFile={this.setFile} isBusy={ isBusy } mobileCartFooter={this.props.mobileCartFooter}/> },
        ...siteSettings.importSettings.clipboard ?[ 
        { title: translate( 'Import from clipboard' ), component: <ClipboardImport 
          validate={ this.validate } 
          updateProducts={ this.updateProducts }
          products={ productList } 
          isBusy={ isBusy }
          onClose={this.props.onClose}
          mobileCartFooter={this.props.mobileCartFooter}
        />,
        image:EditIConNew }]:[]
      ]
    ]; 

    return <div className="import-cart-panel">
      {!this.props.mobileCartFooter?<>
        <MuiIconButton onClick={this.props.onClose} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
      </MuiIconButton>
        <h2 className='export-wishlist'>{translate("Import wishlist")}</h2>
        <Tab tabs={ tabs.filter( tab => tab ) } title="cart-import" />
        </>:
        this.state.component===""?
        <Box height="180px" sx={{display:"flex", flexDirection:"column", alignItems:"flex-start", gap:"24px", alignSelf:"stretch"}}>
             <MuiIconButton onClick={this.props.onClose} width="18px" height="18px" sx={{position:"absolute", top:"12px", right:"12px", background:"transparent", height:"18px", width:"18px", borderRadius:"56px"}}>
                            <Box component="img" style={{width:"inherit", height:"inherit"}} src={closePopup}></Box>
            </MuiIconButton>
          <Box width="100%" sx={{display:"flex",justifyContent:"center",alignItems:"center"}}>
            <span className='mobile-import-header'>{translate("Import options")}</span>
          </Box>
          <Box width="100%" sx={{display:"flex", flexDirection:"column", alignItems:"flex-start", gap:"16px"}}>
              {
                tabs[0].map((tab, key)=>{
                  return <>
                    <div className='mobile-import-tabs' key={key} onClick={()=>{this.setTab(tab)}}>
                      <Box width="100%" sx={{display:"flex", flexDirection:"row", justifyContent:"start", alignItems:"center", gap:"16px"}}>
                          <Box component="img" src={tab.image}></Box>
                          <span className='tabs'>{tab.title}</span>
                      </Box>
                    </div>
                    {key!==tabs[0].length-1&&<Box width="100%" sx={{border:"1px solid #DBDBDB"}}></Box>}
                  </>
                })
              }
          </Box>
        </Box>:
        <>{this.state.component}</>
      }
    </div>;
  }
}

ImportCartPanelComponent.propTypes = {
  addMessage: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  getPrices: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  importExcel: PropTypes.func.isRequired,
  products: PropTypes.shape( {} ),
  captureEvent: PropTypes.func.isRequired,
  siteSettings: PropTypes.shape( {
    importSettings: PropTypes.shape( {
      clipboard: PropTypes.bool,
      excel: PropTypes.bool 
    } )
  } )
};

export const ImportCartPanel = connect( 
  combineStates( productState, siteSettingsState, identityState), 
  combineDispatchers( cartDispatcher, importDispatcher, messageDispatcher, priceDispatcher, productsDispatcher, analyticsDispatcher, superCodeDispatcher, flagDispatcher ) 
)( ImportCartPanelComponent );
